import { LeadTime } from '@digital-bridge/artisan-arya';
import { fromArray, NonEmptyArray } from 'fp-ts/NonEmptyArray';
import * as O from 'fp-ts/Option';

export function getLeadTime(leadTimes: Array<LeadTime | undefined>): string {
    const lts = O.toNullable(fromArray(leadTimes));
    return (lts && aggregateLeadTimes(lts)) ?? '';
}
export function aggregateLeadTimes(
    leadTimes: NonEmptyArray<LeadTime | undefined>,
): string | undefined {
    return leadTimes.reduce(combineLeadTimes)?.description;
}

export function combineLeadTimes(
    a: LeadTime | undefined,
    b: LeadTime | undefined,
): LeadTime | undefined {
    return a && (!b || b.priority > a.priority) ? b : a;
}
